import React from 'react';
import { Box, Divider, Link, Typography } from '@mui/material';

import mobile_check from '../../assets/mobile_check.svg';
import checklist_rtl from '../../assets/checklist_rtl.svg';
import verified_user from '../../assets/verified_user.svg';
import { keyboardFocusVisibleSx } from '../../utils/a11y.utils';

const journeyImages = {
	Register: mobile_check,
	Select_Accounts: checklist_rtl,
	Approve_Consent: verified_user,
};

const linkSx = (customDetails) => ({
	color: customDetails?.primaryColor || '#3053D3',
	fontWeight: 600,
	fontSize: '0.875rem',
	fontFamily: customDetails?.fontFamily,
	cursor: 'pointer',
	verticalAlign: 'baseline',
	textDecoration: 'underline',
	textUnderlineOffset: '2px',
	...keyboardFocusVisibleSx,
});

const JourneySteps = ({
	imgName,
	title,
	description,
	onLearnMore,
	learnMoreLabel,
	learnMoreAriaLabel,
	isLast,
	customDetails,
	isDark,
}) => {
	const image = journeyImages[imgName];

	return (
		<Box component="li" sx={{ listStyle: 'none' }}>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'flex-start',
					gap: '1rem',
					py: '1.25rem',
					px: { xs: '1rem', md: '1.25rem' },
				}}
			>
				<Box
					sx={{
						flexShrink: 0,
						width: 40,
						height: 40,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					{image && (
						<img
							src={image}
							alt=""
							aria-hidden="true"
							style={{ width: 40, height: 40, display: 'block' }}
						/>
					)}
				</Box>
				<Box sx={{ minWidth: 0, flex: 1, textAlign: 'left' }}>
					<Typography
						component="h2"
						sx={{
							fontWeight: 700,
							fontSize: '0.9375rem',
							lineHeight: 1.4,
							mb: '0.375rem',
							textAlign: 'left',
							fontFamily: customDetails?.fontFamily,
							color: isDark ? '#fff' : '#111',
						}}
					>
						{title}
					</Typography>
					<Typography
						sx={{
							fontSize: '0.875rem',
							lineHeight: 1.5,
							textAlign: 'left',
							fontFamily: customDetails?.fontFamily,
							color: isDark ? '#B0B0B0' : '#4A4A4A',
						}}
					>
						{description}
						{onLearnMore && (
							<>
								{' '}
								<Link
									component="button"
									type="button"
									onClick={onLearnMore}
									aria-label={learnMoreAriaLabel || learnMoreLabel}
									sx={linkSx(customDetails)}
								>
									{learnMoreLabel}
								</Link>
							</>
						)}
					</Typography>
				</Box>
			</Box>
			{!isLast && (
				<Divider sx={{ borderColor: isDark ? '#3D3D3D' : '#E8E8E8' }} />
			)}
		</Box>
	);
};

export default JourneySteps;
